
import React from 'react';
import { Helmet } from 'react-helmet-async';

interface OpenGraphImageProps {
  title?: string;
  description?: string;
  image?: string;
  type?: 'website' | 'article' | 'profile' | 'product';
  url?: string;
  imageWidth?: number;
  imageHeight?: number;
}

/**
 * Component for adding Open Graph meta tags to pages
 * Handles both static and dynamic OG images
 */
const OpenGraphImage: React.FC<OpenGraphImageProps> = ({
  title = 'BackLink Hub - SEO Link Marketplace',
  description = 'Buy and sell premium SEO backlinks in a transparent marketplace',
  image = '/og-images/default.png',
  type = 'website',
  url,
  imageWidth = 1200,
  imageHeight = 630,
}) => {
  // Get the current URL if not provided
  const currentUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  
  // Make image URL absolute if it's relative
  const absoluteImageUrl = image.startsWith('http') 
    ? image 
    : `${typeof window !== 'undefined' ? window.location.origin : ''}${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={absoluteImageUrl} />
      <meta property="og:image:width" content={imageWidth.toString()} />
      <meta property="og:image:height" content={imageHeight.toString()} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absoluteImageUrl} />
    </Helmet>
  );
};

export default OpenGraphImage;
